import { createFileRoute, useRouter } from '@tanstack/react-router'
import { Loader2 } from 'lucide-react'
import { useEffect } from 'react'
import { useScopedSettings } from '@/features/settings/ScopedSettings'

export const Route = createFileRoute('/_auth/$orgSlug/profile/')({
  head: () => ({ meta: [{ title: 'My Profile - Snowvault' }] }),
  component: RouteComponent
})

function RouteComponent() {
  const { orgSlug } = Route.useParams()
  const router = useRouter()
  const { openSettings } = useScopedSettings()

  useEffect(() => {
    openSettings({ scope: 'profile', section: 'profile' })
    router.history.replace(`/${orgSlug}`)
  }, [openSettings, orgSlug, router])

  return (
    <div role="status" className="grid min-h-64 place-items-center text-sm text-muted-foreground">
      <span className="inline-flex items-center gap-2">
        <Loader2 className="size-4 animate-spin" aria-hidden="true" /> Opening profile settings
      </span>
    </div>
  )
}
